import { jsPDF as JSPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

const getTypeLabel = (type) => {
  switch (type) {
    case 'shift-change':
      return 'Shift Change';
    case 'shift-swap':
      return 'Shift Swap';
    case 'day-off-change':
    case 'day-off':
      return 'Day Off';
    default:
      return type || '-';
  }
};

const getStatusLabel = (status) => {
  switch (status) {
    case 'approve':
      return 'Approved';
    case 'reject':
      return 'Rejected';
    case 'pending':
      return 'Pending';
    default:
      return status || '-';
  }
};

const formatSchedule = (schedule) => {
  const { shiftStart, shiftEnd } = schedule || {};
  if (!shiftStart || !shiftEnd) return '-';
  return `${moment(shiftStart).format('MMM DD, YYYY hh:mm A')}\n${moment(
    shiftEnd
  ).format('MMM DD, YYYY hh:mm A')}`;
};

const ScheduleChangeRequestsPDF = (requests, fromDate, toDate) => {
  const doc = new JSPDF('l', 'pt', 'a3');
  const totalPagesExp = '{total_pages_count_string}';
  const pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.setFontSize(10);
  doc.text(
    `Period: ${moment(fromDate).format('MMM DD, YYYY')} - ${moment(
      toDate
    ).format('MMM DD, YYYY')}`,
    40,
    60,
    'left'
  );

  const tableRows = requests.map((req) => [
    req.teamMember || '-',
    req.dateRequested
      ? moment(req.dateRequested).format('MMM Do, YYYY h:mm A')
      : '-',
    getTypeLabel(req.type),
    getStatusLabel(req.status),
    formatSchedule(req.originalSchedule),
    formatSchedule(req.newSchedule),
    req.swapWith || '-',
    req.requestReason || '-',
  ]);

  const tableColumn = [
    'Team Member',
    'Requested Date',
    'Type',
    'Status',
    'Original Schedule',
    'New Schedule',
    'Swap With',
    'Reason',
  ];

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 75,
    theme: 'grid',
    styles: { cellPadding: 6, fontSize: 8, overflow: 'linebreak' },
    headStyles: {
      fillColor: [237, 242, 249],
      textColor: [40, 62, 89],
      halign: 'center',
      fontSize: 8,
    },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'center' },
      2: { halign: 'left' },
      3: { halign: 'center' },
      4: { halign: 'left' },
      5: { halign: 'left' },
      6: { halign: 'left' },
      7: { halign: 'left' },
    },
    tableLineColor: [237, 242, 249],
    tableLineWidth: 1,
    showFoot: 'lastPage',
    didDrawPage() {
      doc.setFontSize(14);
      doc.setTextColor(40);
      doc.text('Shift Change Requests', pageWidth / 2, 23, 'center');
      doc.setFontSize(10);
      let str = `Page ${doc.internal.getNumberOfPages()}`;
      if (typeof doc.putTotalPages === 'function') {
        str = `${str} of ${totalPagesExp}`;
      }
      const { pageSize } = doc.internal;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      doc.text(str, pageWidth - 40, pageHeight - 22, { align: 'right' });
    },
  });

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save('schedule_change_requests.pdf');
};

export default ScheduleChangeRequestsPDF;
